import { render } from "./IssuesListPage.vue?vue&type=template&id=72a745da&ts=true"
import script from "./IssuesListPage.vue?vue&type=script&lang=ts"
export * from "./IssuesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__